import RenderComponent from '@/modules/DynamicRenderPage';
import { ROLES } from 'globalconfig/constants/keys';
import { hasRestrictedRole, loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ParentStyled from './style';

let Styled = loadStyle(ParentStyled, 'pages/web/Parts');

const config = loadPageConfig();
const Title = lazy(() => import(`globalcomponents/Title`));
const Content = lazy(() => import(`@/${config.partsInventoryEnabled[1].name}`));
const TopActions =
  config.partsInventoryEnabled[0].children &&
  lazy(() => import(`${config.partsInventoryEnabled[0].children.name}`));

const apiId = 'fetchParts';
const basicRequest = {
  displayLength: '10',
  displayStart: '1',
  sortCol: 'partName',
  sortDir: 'asc'
};

const Parts = (parentProps) => {
  const {
    partsList,
    i18n,
    history,
    theme,
    fetchParts,
    filters,
    callback
  } = parentProps;
  const viewOnly = hasRestrictedRole([ROLES.VIEW_ONLY_FM])

  const [request, setRequest] = useState({
    ...basicRequest
  });
  
  const changeRequest = (fields) => {
    setRequest({ ...basicRequest, ...fields });
  };
  useEffect(() => {
    fetchParts({
      apiId,
      data: { ...request }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request]);
  const commonParentProps = {
    history,
    i18n,
    Styled,
    theme,
    fetchParts,
    filters,
    partsList
  };
  return (
    <>
      <RenderComponent
        {...config.partsInventoryEnabled[0]}
        parentProps={{
          ...parentProps,
          changeRequest,
          request,
        }}
        commonParentProps={commonParentProps}
        component={Title}
        childComponent={TopActions}
      />
      <RenderComponent
        {...config.partsInventoryEnabled[1]}
        parentProps={{
          ...parentProps,
          changeRequest,
          request,
          viewOnly
        }}
        commonParentProps={commonParentProps}
        component={Content}
      />
    </>
  );
};

const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    partsList: state.partsList,
    filters: state.filters
  };
};
const mapDispatch = (dispatch) => {
  return {
    fetchParts: (data) => dispatch.partsList.fetchData(data),
    getFilters: (data) => dispatch.filters.fetchData(data),
    saveParts: (data) => dispatch.partsList.saveParts(data),
    updateParts: (data) => dispatch.partsList.updateParts(data),
    handleDeleteAlert: (data) => dispatch.partsList.handleDeleteAlert(data)
  };
};

export default connect(mapState, mapDispatch)(Parts);
Parts.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  fetchParts: PropTypes.func.isRequired
};
